import {io} from 'socket.io-client'
import '../../../_metronic/assets/sass/components/create-channel.scss'
export function MessageDropdown({setDropdownIndex, messageId}: any) {
  const baseURL: any = process.env.REACT_APP_CHAT_URL
  const deleteMessage = (id: string, messageType: string) => {
    const socket = io(baseURL)
    socket.emit('deleteMessage', {
      messageId: id,
      messageType: messageType,
    })
  }

  return (
    <div
      className='top-100  position-absolute postion_set show menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px show'
      data-kt-menu='true'
    >
      <div className='menu-item px-3 my-0'>
        <div className='menu-link px-3 py-2'>
          <span
            className='menu-title'
            onClick={() => {
              deleteMessage(messageId, 'deleteForMe')
              setDropdownIndex('')
            }}
          >
            Delete for me
          </span>
        </div>
      </div>
      <div className='menu-item px-3 my-0'>
        <div className='menu-link px-3 py-2'>
          <span
            className='menu-title'
            onClick={() => {
              deleteMessage(messageId, 'deleteForEveryOne')
              setDropdownIndex('')
            }}
          >
            Delete for everyone
          </span>
        </div>
      </div>
    </div>
  )
}
